import React from 'react';
import { observer } from 'mobx-react';
import ContractProductsModal from './ContractProductsModal';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import ConfirmRenewalContractFormService from '../services/ConfirmRenewalContractFormService';

class ConfirmRenewalContractProductsModalContainer extends React.Component {
  render() {
    const type = ConfirmRenewalContractFormService.form.getValue('type');
    const version = ConfirmRenewalContractFormService.form.getValue('version');

    return (
      <ContractProductsModal
        options={toJS(ConfirmRenewalContractFormService.productsService.products)}
        onChange={ConfirmRenewalContractFormService.productsService.form.setValue}
        values={ConfirmRenewalContractFormService.productsService.form.getValues()}
        onSubmit={ConfirmRenewalContractFormService.productsService.handleSubmit}
        errors={ConfirmRenewalContractFormService.productsService.form.errors}
        onDelete={ConfirmRenewalContractFormService.productsService.handleDelete}
        loading={ConfirmRenewalContractFormService.productsService.fetch.fetching}
        submitting={ConfirmRenewalContractFormService.submit.fetching}
        currencyType={
          !ConfirmRenewalContractFormService.form.getValue('country') ||
          BRAZIL.includes(ConfirmRenewalContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isModalOpen={ConfirmRenewalContractFormService.productsService.isModalOpen}
        isEditing={ConfirmRenewalContractFormService.productsService.isEditing}
        onAddRange={ConfirmRenewalContractFormService.productsService.handleAddRange}
        onDeleteRange={ConfirmRenewalContractFormService.productsService.handleDeleteRange}
        onReset={ConfirmRenewalContractFormService.productsService.form.reset}
        onClose={ConfirmRenewalContractFormService.productsService.handleToggleModal}
        type={type}
        isV2={version === 'v2'}
        // isEditingContract
      />
    );
  }
}

export default observer(ConfirmRenewalContractProductsModalContainer);
